<section class="border-y flex md:gap-6 gap-4 flex-wrap w-full p-4">
  @for (row of rowData(); track row.uniqueId) {
    <lepi-card [row]="row" [columns]="columns()!" />
  }
</section>
